import { createFileRoute } from '@tanstack/react-router'
import MotivosPerdasPage from '@/pages/dashboard/motivos-perdas-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/motivos-perdas',
)({
  component: function MotivosPerdasRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <MotivosPerdasPage />
      </ProtectedRoute>
    )
  },
})
